import styled, { css } from 'styled-components';
import { dayWrapper } from '@widgets/shared/components/CustomDatepicker/components/DatepickerDay/styles/default';
export const Dot = styled.span ``;
export const Number = styled.span ``;
export const Price = styled.span ``;
export const Wrapper = styled.div `
  ${dayWrapper}
  
  ${({ theme: { calendarDay, calendarDayDot, calendarDayHover, calendarDayHighlighted, calendarDayNumber, calendarDayNumberHover, calendarDayNumberHighlighted, calendarDayPrice, calendarDayPriceHover, calendarDayPriceHighlighted, calendarDayNumberDisabled, }, lowAvailability, highAvailability, averageAvailability, soldOut, selected, showAvailability, }) => css `
    ${calendarDay}

    ${Dot} {
      display: none;
      ${calendarDayDot}

      ${showAvailability && css `
        ${highAvailability && css `
          background-color: var(--high-availability);
        `}

        ${averageAvailability && css `
          background-color: var(--average-availability);
        `}

        ${lowAvailability && css `
          background-color: var(--low-availability);
        `}

        ${soldOut && css `
          display: block;
          background-color: var(--no-availability);
        `}
      `}
    }

    ${Number} {
      ${calendarDayNumber}

      .react-datepicker__day--disabled & {
        ${calendarDayNumberDisabled}
      }
    }
    
    ${Price}{
      ${calendarDayPrice}
      
      ${css `
        @media screen and (max-width: 320px) {
          font-size: 1rem;
          line-height: 1.2rem;
        }
      `}
    }
    
    &:hover {
      ${calendarDayHover}
      
      ${Number}{
        ${calendarDayNumberHover}
      }

      ${Price}{
        ${calendarDayPriceHover}
      }
    }
    
    ${selected && css `
      ${calendarDayHighlighted}
      
      ${Number}{
        ${calendarDayNumberHighlighted}
      }
      
      ${Price}{
        ${calendarDayPriceHighlighted}
      }
    `}
  `}
`;
export default {
    Dot,
    Price,
    Number,
    Wrapper,
};
